var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71758 2.89497L1.36508 13.5C1.2341 13.7268 1.1648 13.9839 1.16407 14.2459C1.16334 14.5078 1.23119 14.7653 1.3609 14.9929C1.4906 15.2204 1.67762 15.41 1.90336 15.5429C2.12909 15.6757 2.38568 15.7471 2.64758 15.75H15.3526C15.6145 15.7471 15.8711 15.6757 16.0968 15.5429C16.3225 15.41 16.5096 15.2204 16.6393 14.9929C16.769 14.7653 16.8368 14.5078 16.8361 14.2459C16.8354 13.9839 16.766 13.7268 16.6351 13.5L10.2826 2.89497C10.1489 2.67455 9.96062 2.49231 9.73597 2.36583C9.51133 2.23936 9.25788 2.17291 9.00008 2.17291C8.74227 2.17291 8.48882 2.23936 8.26418 2.36583C8.03953 2.49231 7.85128 2.67455 7.71758 2.89497V2.89497Z",
    stroke: "#FF1F12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75V9.75",
    stroke: "#FF1F12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.75H9.0075",
    stroke: "#FF1F12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiAlertTriangle);
export default __webpack_public_path__ + "static/media/fi_alert-triangle.a6d12d1489feeb7792e6312183d11827.svg";
export { ForwardRef as ReactComponent };